import React from 'react';
import './NotFound.css';

const NotFound: React.FC = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">Page not found</p>
        <p className="not-found-support">
          Need help? Contact us at{' '}
          <a href="mailto:support@codec422.com">support@codec422.com</a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
